const TXN_ID_DISPLAYED_SUBSTRING_CHAR_LENGTH = 5;

function getDisplayTextForTxnID(id: string) {
  return `${id.substring(0, TXN_ID_DISPLAYED_SUBSTRING_CHAR_LENGTH)}...${id.substring(
    id.length - TXN_ID_DISPLAYED_SUBSTRING_CHAR_LENGTH
  )}`;
}

export {getDisplayTextForTxnID};
